import React from 'react';
import {Alert} from '@mui/material';

export default function AlertNotification({message}) {
    return (
        <Alert severity="warning" sx={{mb: 2}}>
            {message}
        </Alert>
    );
}
